<template>
  <div class="wrapper box  box_v">
    <page-head title="进出统计" :btn-list="btnList" :show-back="false" @handleBtn="handleBtn">
    </page-head>
    <div class="box_f1 box_v card-box">
      <Card dis-hover :padding="20">
            <i-form ref="formInline" inline label-position="top">
              <row :gutter="80">
                <i-col span="8">
                  <FormItem label="姓名" prop="name">
                    <Input v-model="name" placeholder="请输入姓名" clearable @on-enter="initRecordList" @on-clear="initRecordList"/>
                  </FormItem>
                </i-col>
                <i-col span="8">
                  <FormItem label="联系电话" prop="phone">
                    <Input v-model="phone" placeholder="请输入联系电话" clearable @on-enter="initRecordList"  @on-clear="initRecordList"/>
                  </FormItem>
                </i-col>
                <i-col span="8">
                  <FormItem label="出入类型" prop="walkType">
                    <Select v-model="walkType"  @on-change="initRecordList">
                      <Option value="in" key="in">进门</Option>
                      <Option value="out" key="out">出门</Option>
                    </Select>
                  </FormItem>
                </i-col>
                <i-col span="8">
                  <FormItem label="时间" prop="time">
                    <DatePicker v-model="time" type="daterange" placeholder="请选择时间" @on-change="initRecordList"></DatePicker>
                  </FormItem>
                </i-col>
                 <i-col span="8">
                  <FormItem label="最低体温" prop="minTemperature">
                    <Input v-model.number="minTemperature" placeholder="请输入体温范围" clearable @on-enter="initRecordList"  @on-clear="initRecordList"/>
                  </FormItem>
                </i-col>
                 <i-col span="8">
                  <FormItem label="最高体温" prop="maxTemperature">
                    <Input v-model.number="maxTemperature" placeholder="请输入体温范围" clearable @on-enter="initRecordList"  @on-clear="initRecordList"/>
                  </FormItem>
                </i-col>
                <!-- <i-col span="8" v-if="isJiedao">
                  <select-community ref="community" @communityChange="communityChange"></select-community>
                </i-col> -->
                <!-- <i-col span="8" v-else>
                  <FormItem label="所属小区" prop="host">
                    <Select v-model="zoneId" class="input" clearable @on-change="initRecordList">
                      <Option v-for="item in zoneList" :value="item.zoneId" :key="item.zoneId">{{ item.zoneName }}</Option>
                    </Select>
                  </FormItem>
                </i-col>
                <i-col span="8" v-if="isJiedao">
                  <FormItem label="所属小区" prop="host">
                    <Select v-model="zoneId" class="input" @on-open-change="selectZone" clearable @on-change="initRecordList">
                      <Option v-for="item in zoneList" :value="item.zoneId" :key="item.zoneId">{{ item.zoneName }}</Option>
                    </Select>
                  </FormItem>
                </i-col> -->
              </row>
            </i-form>
      </Card>
      <Card dis-hover :padding="20" class="box_f1" style="margin-top: 20px">
        <div class="table-card">
          <Table border :columns="settingColumn" :data="recordList" :loading="isTableLoading" @on-row-dblclick="clickRow" ></Table>
          <page :total="total" @on-change="pageChange" class="page" :page-size="rows" :current="page" show-total/>
        </div>
      </Card>
    </div>

  </div>
</template>

<script>
  var that
  import pageHead from '../../../components/head'
  import selectCommunity from '../../../components/selectCommunity'
  
  export default {
    name: 'walkRecord',
    components: {
      pageHead,
      selectCommunity
    },
    data () {
      return {
        btnList:[{
          name: '搜索',
          type: 'search',
          loading: false,
        }, {
          name: '重置',
          type: 'init',
          loading: false,
        },{
          name: '导出',
          type: 'export',
          loading: false,
        }],
        name:'',
        phone:'',
        minTemperature:"",
        maxTemperature:"",
        communityId:0,
        time:[],
        childShequ:[],
        zoneId:'',
        zoneList:[],
        isLoadZoneList: false,
        walkType:'',
        recordList:[],
        isTableLoading:false,
        settingColumn: [
          {
            title: "姓名",
            width: '95',
            resizable: true,
            key: "name"
          },
          {
            title: "身份证号",
            key: 'cardno',
            resizable: true,
          },
          {
            title: "联系电话",
            key: "phone",
            resizable: true,
          },
          // {
          //   title: "行政区域",
          //   key: "communityName"
          // },
          // {
          //   title: '居住地址',
          //   key: 'address'
          // },
          {
            title: '出入类型',
            key: 'walkType'
          },
          {
            title:'时间',
            key:'time'
          },
          {
            title:'体温',
            key:'num'
          },
          {
            title: "操作",
            render: function (h, params) {
              return h("div",
                [
                  h(
                    "span",
                    {
                      style: {
                        color: "#5e6d94",
                      },
                      on: {
                        click: (e) => {
                          e.stopPropagation()
                          that.gotoDetail(params.index)
                        }
                      }
                    },
                    "[详情]"
                  ),
                ]);
            }
          },
        ],
        page:1,
        rows:6,
        total:0,
        //级联行政区域
        communityIdList:[]
      }
    },
    watch: {},
    computed: {},
    methods:{
       clickRow(value) {
        this.$router.push({
          name: 'fangyidetail',
          query: {
            id: value.id,
            communityId: value.communityId
          }
        })
      },
      getRecordList () {
        var beginTime='',endTime=''
        if (this.time[0])  {
          beginTime = this.$util.FormatDate(new Date(this.time[0]),'yyyy-MM-dd')
          endTime = this.$util.FormatDate(new Date(this.time[1]),'yyyy-MM-dd')
        }
        this.$get(this.urlobj.getWalkRecord,{
          pageNum:this.page,
          pageSize:this.rows,
          zoneId:this.zoneId,
          communityIdList:this.communityIdList.length?this.communityIdList.join(','):'',
          walkType:this.walkType,
          comeId: this.$route.query.companyId,
          comeType:3,
          userName:this.name,
          phoneNO:this.phone,
          beginTime,
          endTime,
          maxTemperature: this.maxTemperature?parseInt(this.maxTemperature * 10 * 10): "",
          minTemperature: this.minTemperature?parseInt(this.minTemperature * 10 * 10): ""
        }).then(res => {
          this.recordList = res.rows.map(item => {
            return {
              communityId:item.communityId,
              communityName:item.communityName,
              name:item.userName,
              cardno:item.idCardNO,
              phone:item.phoneNO,
              address:item.address,
              walkType:item.walkType == 'in'?'进门':'出门',
              num:item.temperature/100+'℃',
              time:item.createTime?this.$util.FormatDate(item.createTime,'yyyy-MM-dd HH:mm:ss'):'',
              id:item.peopleId
            }
          })
          this.total = res.total
        })
      },
      handleBtn(type) {
        if (type == 'export') {
          this.export()
        } else if (type == 'search') {
          this.initRecordList()
        }else if (type == 'init') {
          this.name = ''
          this.phone = ''
          this.walkType = ''
          this.zoneId = ''
          this.time = []
          this.communityId = 0
          this.communityIdList = []
          this.minTemperature = ""
          this.maxTemperature = ""
          this.initRecordList()
        }
      },
      export () {
        var beginTime='',endTime=''
        let minTemperature='',maxTemperature=''
        minTemperature = this.minTemperature?parseInt(this.minTemperature * 10 * 10):""
        maxTemperature = this.maxTemperature?parseInt(this.maxTemperature * 10 * 10):""
        if (this.time[0])  {
          beginTime = this.time[0]?this.$util.FormatDate(new Date(this.time[0]),'yyyy-MM-dd'):""
          endTime = this.time[1]?this.$util.FormatDate(new Date(this.time[1]),'yyyy-MM-dd'):''
        }
        let url = this.urlobj.exportWalkReport
          + '?walkType='
          + (this.walkType? this.walkType: "")
          + '&userName='
          + (this.name? this.name: "")
          + '&phoneNO='
          + (this.phone? this.phone: "")
          + '&token='
          + this.$store.state.access_token
          + '&beginTime='
          +  beginTime
          + '&endTime='
          + endTime
          + '&minTemperature='
          + minTemperature
          + '&maxTemperature='
          + maxTemperature
          + '&comeId='
          + this.$route.query.companyId
          + '&comeType=3'
        console.log(url)
        window.open(url)
      },
      initRecordList () {
        this.page = 1
        this.getRecordList()
      },
      gotoDetail (index) {
        var id = this.recordList[index].id,
          communityId = this.recordList[index].communityId
        this.$router.push({
          name: 'fangyidetail',
          query: {id, communityId}
        })
      },
      pageChange(val) {
        this.page = val;
        this.getRecordList();
      },
    },
    mounted () {
      console.log(this.$route.query.companyId)
      that = this
      this.getRecordList()
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .ivu-form .ivu-form-item-label {
    font-size: 16px;
  }

  /deep/ .ivu-form-inline .ivu-form-item {
    display: block;
  }

  /deep/ .ivu-date-picker {
    display: block;
  }

  /deep/ .ivu-card-body {
    height: 100%;
  }

  /deep/ .ivu-table-tip {
    overflow-x: hidden;
  }
  .wrapper {
    height: 100%;
  }
  .card-box {
    margin: 0 20px 20px;
  }
  .table-card {
    padding: 20px 0px 80px;
    position: relative;
    height: 100%;
    text-align: right;
  }
  .page {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  }
</style>
